<template>
    <v-dialog max-width="80%" v-model="dialog">
        <v-card class="ma-0 pa-0">
            <v-card-actions>
                <v-card-text>Key: <v-chip color="blue" small class="white--text">{{this.keyName}}</v-chip></v-card-text>
                <v-spacer></v-spacer>
                <v-btn icon class="ma-1" color="grey" @click="onClose">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-actions>
            <v-card-actions class="mt-n4">
                <v-card width="100%" elevation="0">
                    <v-card-actions>
                        <v-card width="100%" elevation="0" class="ml-2">
                            <v-card-actions class="ma-0 pa-0">
                                <v-chip color="orange" class="white--text" small>Old value</v-chip>
                            </v-card-actions>
                        </v-card>
                    </v-card-actions>
                    <v-card-actions>
                        <v-card elevation="0" outlined height="200px" width="100%" :style="borderLeft" @click="selectPart(0)" :ripple="false">
                            <v-card-actions>
                                <v-card-text class="ma-1 pa-1">{{this.oldValue}}</v-card-text>
                            </v-card-actions>
                        </v-card>
                    </v-card-actions>
                </v-card>
                <v-card width="100%" elevation="0" class="mt-0">
                    <v-card-actions>
                        <v-card width="100%" elevation="0" class="ml-2">
                            <v-card-actions class="ma-0 pa-0">
                                <v-chip color="green" class="white--text" small>New value</v-chip>
                            </v-card-actions>
                        </v-card>
                    </v-card-actions>
                    <v-card-actions>
                        <v-card elevation="0" outlined height="200px" width="100%" :style="borderRight" @click="selectPart(1)" :ripple="false">
                            <v-card-actions>
                                <v-card-text class="ma-1 pa-1">{{this.newValue}}</v-card-text>
                            </v-card-actions>
                        </v-card>
                    </v-card-actions>
                </v-card>
            </v-card-actions>
            <v-card-actions>
                <v-btn class="ma-2 white--text" color="red" elevation="0" @click="onPressSkip">SKIP</v-btn>
                <v-spacer></v-spacer>
<!--                <v-btn class="ma-2" color="primary">ADD WARNING</v-btn>-->
                <v-spacer></v-spacer>
                <v-btn class="ma-2" color="primary" elevation="0" @click="onPressNext">NEXT</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: "l-merge-key-popup",
    props: {},
    data: () => ({
        dialog: false,
        onMerge:null,
        oldValue:"",
        newValue:"",
        keyName:"",
        selectedPart:1,
        borderLeft:{},
        borderRight:{},
    }),
    computed:{
    },
    mounted() {
        // this.oldValue = 'liquam a purus vel ipsum pharetra vestibulum. Donec tempus sodales lacinia. Aliquam sit amet lacus id turpis viverra finibus. Donec scelerisque maximus ex, quis condimentum tortor efficitur commodo. Nulla sagittis arcu ac lacus maximus congue. Phasellus feugiat faucibus ex. Duis porta massa leo, iaculis venenatis erat volutpat iaculis.';
        // this.newValue = 'Suspendisse potenti. In laoreet viverra dolor, sit amet aliquam ante faucibus quis. Vivamus felis mauris, condimentum sed sagittis id, mattis id diam. ';
    },
    methods: {
        show(keyName, oldValue, newValue, onMerge) {
            this.onMerge = onMerge;
            this.oldValue = oldValue;
            this.newValue = newValue;
            this.keyName = keyName;
            this.dialog = true;
            this.selectedPart = 1;
            this.selectPart(1);
        },
        onClose() {
            this.dialog = false
        },
        onPressSkip(){
            if (this.onMerge != null){
                this.onMerge(null);
            }
            this.dialog = false
        },
        onPressNext(){
            if (this.onMerge != null) {
                this.onMerge(this.selectedPart == 0 ? this.oldValue : this.newValue);
            }
            this.dialog = false
        },
        selectPart(part){
            this.selectedPart = part;
            if (part == 0){
                this.borderRight = {"border": 'lavender solid 1px'}
                this.borderLeft = {"border": 'RoyalBlue solid 1px'}
            }else{
                this.borderRight = {"border": 'SeaGreen solid 1px'}
                this.borderLeft = {"border": 'lavender solid 1px'}
            }
        },
    }
}

</script>

<style scoped>
.v-card--link:before {
    background: none;
}
</style>